import React from 'react'
import { ChevronDownIcon } from '@heroicons/react/16/solid'
import DiscountRulesSummary from "./discount-rules-summary";

export default function ListDiscounts({ policies, setUiState, discountId, updateDiscountPolicy, discount }) {
  if(policies.policyItems.length === 0 || policies.pagination.total === 0) {
    return (
      <div>
        <h2 className="font-bold mb-3">Discount Policy</h2>
        <p className="italic mb-3">No discounts exist.</p>
        <button type="button"
                className="rounded bg-white px-2 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20"
                onClick={(e) => {
                  e.preventDefault();
                  setUiState("new")
                }}
        >
          Create Discount
        </button>
      </div>
    )
  } else {
    return (
      <div>
        <div className="flex">
          <h2 className="font-bold mb-3">Discount Policy</h2>
          <button type="button"
                  className="ml-auto rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:ring-white/5 dark:hover:bg-white/20"
                  onClick={(e) => {
                    e.preventDefault();
                    setUiState('new')
                  }}
          >
            New Policy
          </button>
        </div>

        <div className="mt-2 grid grid-cols-1">
          <select
            id="discount"
            name="discount"
            className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:*:bg-gray-800 dark:focus-visible:outline-indigo-500"
            value={discountId || ""}
            onChange={(e) => {
              e.preventDefault();
              updateDiscountPolicy(e.target.value)
            }}
          >
            <option value="" disabled>Select a Discount</option>
            { policies.policyItems.map((policy, index) => {
              return (
                <option key={index} value={policy.id}>{policy.title}</option>
              )
            })}
          </select>

          { discount && (
            <DiscountRulesSummary
              discount={discount}
            />
          )}
        </div>
      </div>
    )
  }
}
